import { Box, Typography, Divider, useMediaQuery } from "@mui/material";
import ModalCard from "../../../components/ModalCard";
import EditReviewForm from "../AddReviewForm";
import {
  blackColor,
  blackColor27,
  headingColor,
  whiteColor,
} from "configs/styles/muiThemes";

/**
 * Edit Existing Personal Reviews dialog
 * @param ownReview
 * @param open
 * @param onClose
 * @param getOwnReviewDetails
 * @param getSummary
 *  @author Rupesh
 */
const EditReview = ({
  ownReview,
  open,
  getOwnReviewDetails,
  getSummary,
  onClose,
}) => {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const handleUpdateReviewClose = () => {
    getOwnReviewDetails();
    getSummary();
    onClose();
  };

  return matches ? (
    <Box sx={{ backgroundColor: whiteColor, borderRadius: "10px", mb: 1 }}>
      <Typography
        variant="h4"
        fontSize={15}
        fontWeight={600}
        color={blackColor}
        textAlign="center"
      >
        Update your Review
      </Typography>

      <EditReviewForm
        isUpdate={true}
        ownReview={ownReview}
        onClose={() => onClose()}
        getOwnReviewDetails={() => getOwnReviewDetails()}
        getSummary={() => getSummary()}
      />
    </Box>
  ) : (
    <ModalCard
      handleClose={handleUpdateReviewClose}
      open={open}
      mobileBottom
      mobileWidth="100%"
      br="14px 14px 0 0"
    >
      <Box sx={{ backgroundColor: whiteColor }}>
        <Box sx={{ p: "6px 12px", borderBottom: `1px solid #00000017` }}>
          <Typography
            variant="h4"
            sx={{
              fontSize: "13px",
              color: blackColor27,
              fontWeight: 600,
              display: "inline",
              lineHeight: "13px",
            }}
          >
            Update your Review
          </Typography>
        </Box>

        <EditReviewForm
          styles={{ p: "10px 15px" }}
          isUpdate={true}
          ownReview={ownReview}
          onClose={() => onClose()}
          getOwnReviewDetails={() => getOwnReviewDetails()}
          getSummary={() => getSummary()}
        />
      </Box>
    </ModalCard>
  );
};

export default EditReview;
